export default __webpack_public_path__ + "static/media/thaihealth-logo.39fe992d.svg";